import { useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import Ijtimai from '../../../assets/images/Ijtimai.jpg';
import Premium from '../../../assets/images/Premium.png';
import Asaan from '../../../assets/images/Asaan.png';
import Raseed from '../../../assets/images/reseedbot_1.jpg';
import Footer from '../../../assets/images/contact.png';

export function Slip() {
  const location = useLocation();
  const [slipData, setSlipData] = useState(null);
  const hasPrintedRef = useRef(false);

  useEffect(() => {
    // Pehle React Router ki state check karein
    if (location.state?.paymentData) {
      setSlipData(location.state.paymentData);
    } else {
      // Agar naya tab hai, to LocalStorage se uthayen
      const savedData = localStorage.getItem('temp_slip_data');
      if (savedData) {
        setSlipData(JSON.parse(savedData));
      } else {
        console.error("Data not found in State or LocalStorage");
      }
    }
  }, [location.state]);

  const getHeaderImage = () => {
    const type = slipData?.animal_type?.toLowerCase();
    if (type?.includes('cow -  asaan', 'goat -  asaan')) return Asaan;
    if (type?.includes('cow -  ijtimai', 'cow -  ijtimai')) return Ijtimai;
    if (type?.includes('cow -  premium')) return Premium;
    return Ijtimai;
  };

  useEffect(() => {
    if (slipData && !hasPrintedRef.current) {
      hasPrintedRef.current = true;
      const timer = setTimeout(() => {
        window.print();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [slipData]);

  if (!slipData) {
    return (
      <div className="p-10 text-center">
        <h3>Loading Slip Data...</h3>
        <p>Agar data load nahi ho raha, to purana tab band karke dobara koshish karein.</p>
      </div>
    );
  }

  const getReceiptNo = () => slipData.receipt_no || slipData.customer_id || 'N/A';
  const formatAmount = () => slipData.amount?.toLocaleString('en-PK') || '0';

  // Watermark Condition: Partially Paid ya Pending par dikhega
  const showWatermark = slipData.payment_status === 'partially_paid' || slipData.payment_status === 'pending';

  return (
    <div className="a4-page-wrapper print-area" style={{ border: '2px solid #000', paddingTop: '20px' }}>
      <style>{`
        @page {
          size: A4;
          margin: 5mm;
          border: 2px solid #000;
          left :10px
        }
        @media print {
          body { 
            visibility: hidden;
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-print-color-adjust: exact; 
          }
          .print-area { 
            visibility: visible !important;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            width: 90% !important;
          }
          .print-area * { 
            visibility: visible !important; 
          }
          .no-print { display: none; }
        }
        
        /* Watermark Styling */
        .watermark-container {
          position: relative;
          overflow: hidden;
        }
        .watermark-text::before {
          content: "PENDING";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
          font-size: 100px;
          font-weight: bold;
          color: rgba(255, 0, 0, 0.15); /* Halka laal rang */
          z-index: 0;
          pointer-events: none;
          white-space: nowrap;
        }

        .a4-page-wrapper { 
          width: 190mm; 
          margin: auto; 
          background: #fff; 
          font-family: 'Segoe UI', Arial, sans-serif;
          color: #000;
          padding: 10px;
        }
        .headers { width: 100%; height: auto;  display: block; padding-bottom:5px ;margin-bottom: 5px;}
        .section-box { border: 1px solid #000; padding: 15px; margin-bottom: 10px; position: relative; z-index: 1; }
        .table-custom { width: 100%; border-collapse: collapse; padding-top 2px;line-height: .9; font-size: 15px; }
        .table-custom td { border: 2px solid #000; padding: 8px 10px; vertical-align: middle; }
        .token-container { display: flex; gap: 10px; text-align: center;margin: 10px 0; }
        .token-box { flex: 1; border: 2px dashed #000; padding: 10px; text-align: center; }
        .dashed-divider { border-top: 2px dashed #000; margin: 10px 0; width: 100%; position: relative; }
        .fw-bold { font-weight: bold; }
        .text-center { text-align: center; }
      `}</style>

      {/* --- CUSTOMER COPY SECTION --- */}
      <div className={`customer-section ${showWatermark ? 'watermark-container watermark-text' : ''}`}>

        <img src={getHeaderImage()} alt="header" className="py-1" />

        <div className="section-box">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <h5 className="text-left fw-bold" style={{ margin: '0 0 8px 0', textDecoration: 'underline' }}>CUSTOMER COPY </h5>
            <span style={{
              fontWeight: '900',
              fontSize: '15px',
              textTransform: 'uppercase',
              color: slipData.payment_status === 'paid' ? '#166534' : '#92400e',
              border: `2px solid ${slipData.payment_status === 'paid' ? '#166534' : '#92400e'}`,
              padding: '2px 12px',
              borderRadius: '4px',
              backgroundColor: slipData.payment_status === 'paid' ? '#dcfce7' : '#fef3c7'
            }}>
              {slipData.payment_status?.replace('_', ' ')}
            </span>
          </div >
          <table className="table-custom">
            <tbody>
              <tr>
                <td style={{ width: '25%' }} className="fw-bold">Share Person:</td>
                <td style={{ width: '45%' }}>{slipData.first_name.toUpperCase()}</td>
                <td style={{ width: '15%' }} className="fw-bold">Receipt No:</td>
                <td style={{ width: '20%' }}>{getReceiptNo()}</td>
              </tr>
              <tr>
                <td className="fw-bold">Father/Husband:</td>
                <td>{slipData.last_name.toUpperCase()}</td>
                <td className="fw-bold">Animal:</td>
                <td>{slipData.animal_type}</td>
              </tr>
              <tr>
                <td className="fw-bold">Address:</td>
                <td style={{ fontSize: '11px' }}>{slipData.address}</td>
                <td className="fw-bold">Animal No:</td>
                <td className="fw-bold" style={{ fontSize: '18px' }}>{slipData.animal_number}</td>
              </tr>
              <tr>
                <td className="fw-bold">Mobile No:</td>
                <td>{slipData.phone}</td>
                <td className="fw-bold">Share#:</td>
                <td>{slipData.share_no}</td>
              </tr>
              <tr>
                <td className="fw-bold">Waqf (Meat):</td>
                <td>{slipData.feasabilillah ? 'Yes' : 'No'}</td>
                <td className="fw-bold">Day:</td>
                <td>Day {slipData.slaughtering_day}</td>
              </tr>
              <tr>
                <td className="fw-bold">Payment Mode</td>
                <td className="fw-bold capitalize">{slipData.payment.toUpperCase()}</td>
                <td className="fw-bold" >Amount:</td>
                <td className="fw-bold" >Rs. {formatAmount()}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <img src={Raseed} alt="header" className="py-1" />
        </div>

        <div className="token-container">
          <div className="token-box">
            <h6 className="fw-bold" style={{ borderBottom: '1px solid #000', paddingBottom: '3px' }}>TOKEN 1 (Gate Pass)</h6>
            <div style={{ textAlign: 'left', marginTop: '5px' }}>
              <p><b>Name: </b>{slipData.first_name}</p>
              <p><b>Receipt:</b> {getReceiptNo()} | <b>Day:</b> {slipData.slaughtering_day}</p>
              <p><b>Animal/Share:</b> {slipData.animal_type} / {slipData.animal_number} / {slipData.share_no}</p>
              <p className="text-center" style={{ marginTop: '8px', borderTop: '1px solid #ccc' }}>Sign: ________________</p>
            </div>
          </div>
          <div className="token-box">
            <h6 className="fw-bold" style={{ borderBottom: '1px solid #000', paddingBottom: '3px' }}>TOKEN 1 (Gate Pass)</h6>
            <div style={{ textAlign: 'left', marginTop: '5px' }}>
              <p><b>Name: </b>{slipData.first_name}</p>
              <p><b>Receipt:</b> {getReceiptNo()} | <b>Day:</b> {slipData.slaughtering_day}</p>
              <p><b>Animal/Share:</b> {slipData.animal_type} / {slipData.animal_number} / {slipData.share_no}</p>
              <p className="text-center" style={{ marginTop: '8px', borderTop: '1px solid #ccc' }}>Sign: ________________</p>
            </div>
          </div>
        </div>
        <img src={Footer} alt="footer" className="headers" style={{ marginTop: '50px', maxHeight: '50px' }} />
      </div>

      <div className="dashed-divider"></div>

      {/* --- OFFICE COPY SECTION --- */}
      <div className={`office-section section-box ${showWatermark ? 'watermark-container watermark-text' : ''}`}>
        <h5 className="text-center fw-bold">OFFICE COPY</h5>
        <table className="table-custom">
          <tbody>
            <tr>
              <td style={{ width: '25%' }} className="fw-bold">Share Person:</td>
              <td style={{ width: '45%' }}>{slipData.first_name.toUpperCase()} </td>
              <td style={{ width: '15%' }} className="fw-bold">Receipt No:</td>
              <td style={{ width: '20%' }}>{getReceiptNo()}</td>
            </tr>
            <tr>
              <td className="fw-bold">Father/Husband:</td>
              <td>{slipData.last_name.toUpperCase()}</td>
              <td className="fw-bold">Animal:</td>
              <td>{slipData.animal_type}</td>
            </tr>
            <tr>
              <td className="fw-bold">Address:</td>
              <td style={{ fontSize: '11px' }}>{slipData.address}</td>
              <td className="fw-bold">Animal No:</td>
              <td className="fw-bold" style={{ fontSize: '18px' }}>{slipData.animal_number}</td>
            </tr>
            <tr>
              <td className="fw-bold">Mobile No:</td>
              <td>{slipData.phone}</td>
              <td className="fw-bold">Share#:</td>
              <td>{slipData.share_no}</td>
            </tr>
            <tr>
              <td className="fw-bold">Waqf (Meat):</td>
              <td>{slipData.feasabilillah ? 'Yes' : 'No'}</td>
              <td className="fw-bold">Day:</td>
              <td>Day {slipData.slaughtering_day}</td>
            </tr>
            <tr>
              <td className="fw-bold">Payment Mode</td>
              <td className="fw-bold capitalize">{slipData.payment.toUpperCase()}</td>
              <td className="fw-bold" >Amount:</td>
              <td className="fw-bold">Rs. {formatAmount()}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
          <span>Date: {new Date().toLocaleDateString()}</span>
        </div>
      </div>
    </div>
  );
}